import React, { useState, useEffect } from "react";
import {
  Box,
  Container,
  Heading,
  VStack,
  useColorModeValue,
  Text,
  Button,
  HStack,
  Badge,
  Divider,
  FormControl,
  Textarea,
  IconButton,
  Tooltip,
  useToast,
  Input,
  Select,
  NumberInput,
  NumberDecrementStepper,
  NumberIncrementStepper,
  NumberInputStepper,
  NumberInputField,
  CheckboxGroup,
  Checkbox,
  Stack,
} from "@chakra-ui/react";
import { useTranslation } from "react-i18next";
import { PrivateNavbar } from "../../components/layout/PrivateNavbar";
import { Footer } from "../../components/layout/Footer";
import { FiSend, FiArrowLeft } from "react-icons/fi";
import { useNavigate, useParams } from "react-router-dom";
import { SubUser } from "../../types";
import { subUsersAPI } from "services/subuser-api";

export const EditSubuser: React.FC = () => {
  const { t, i18n } = useTranslation();
  const navigate = useNavigate();
  const { id } = useParams<{ id: string }>();
  const toast = useToast();
  const bgColor = useColorModeValue("gray.50", "gray.900");
  const cardBg = useColorModeValue("white", "gray.800");
  const [subuser, setSubuser] = useState<SubUser | null>(null);
  useEffect(() => {
    if (id) {
      loadSubuser();
    }
  }, [id]);

  const loadSubuser = async () => {
    try {
      const data = await subUsersAPI.getSubUser(id!);
      setSubuser(data);
    } catch (error) {
      console.error("Error loading subuser:", error);
      toast({
        title: t("subusers.error"),
        status: "error",
        duration: 3000,
      });
    }
  };

  const handleUpdateSubuser = async () => {
    try {
      if (subuser) {
        // remove userId property from agent
        // delete subuser.userId;
        // delete subuser.user;
        console.log(subuser);
        await subUsersAPI.updateSubUser(id!, subuser);
        toast({
          title: t("subusers.updated"),
          status: "success",
          duration: 3000,
        });
      }
    } catch (error) {
      console.error("Error updating subuser:", error);
      toast({
        title: t("subusers.error"),
        status: "error",
        duration: 3000,
      });
    }
  };

  if (!subuser) {
    return null;
  }

  return (
    <Box minH="100vh" display="flex" flexDirection="column">
      <PrivateNavbar />

      <Box flex="1" bg={bgColor} py={20}>
        <Container maxW="container.xl">
          <VStack spacing={8} align="stretch">
            {/* Header */}
            <HStack spacing={4}>
              <IconButton
                aria-label="Back to subusers"
                icon={<FiArrowLeft />}
                onClick={() => navigate("/subusers")}
              />
              <VStack align="start" spacing={2} flex={1}>
                <Heading
                  size="xl"
                  fontFamily="Nasalization"
                  bgGradient="linear(to-r, brand.primary, brand.secondary)"
                  bgClip="text"
                >
                  {subuser.name}
                </Heading>
                <HStack spacing={4}>
                  <Text color="gray.500">
                    {t("subusers.created", {
                      date: new Date(subuser.createdAt).toLocaleDateString(
                        i18n.language === "pt-BR" ? "pt-BR" : "en-US"
                      ),
                    })}
                  </Text>
                </HStack>
              </VStack>
            </HStack>

            {/* Subuser Content */}
            <VStack spacing={6} bg={cardBg} p={8} borderRadius="xl" shadow="md">
              {/* Name */}
              <VStack align="stretch" w="full" spacing={4}>
                <Heading size="md">{t("subusers.name")}</Heading>
                <Input
                  value={subuser.name}
                  onChange={(e) =>
                    setSubuser({ ...subuser, name: e.target.value })
                  }
                />
              </VStack>

              {/* Description */}
              <VStack align="stretch" w="full" spacing={4}>
                <Heading size="md">{t("subusers.email")}</Heading>
                <Input
                  value={subuser.email}
                  onChange={(e) =>
                    setSubuser({ ...subuser, email: e.target.value })
                  }
                  type="email"
                />
              </VStack>

              {/* System Prompt */}
              <VStack align="stretch" w="full" spacing={4}>
                <Heading size="md">{t("subusers.password")}</Heading>
                <Input
                  value={subuser.password}
                  onChange={(e) =>
                    setSubuser({ ...subuser, password: e.target.value })
                  }
                  type="password"
                />
              </VStack>

              {/* Model */}
              <VStack align="stretch" w="full" spacing={4}>
                <Heading size="md">{t("subusers.phone")}</Heading>
                <Input
                  value={subuser.phone}
                  onChange={(e) =>
                    setSubuser({ ...subuser, phone: e.target.value })
                  }
                />
              </VStack>

              {/* Phone */}
              <VStack align="stretch" w="full" spacing={4}>
                <Heading size="md">{t("subusers.phone")}</Heading>
                <Input
                  value={subuser.phone}
                  onChange={(e) =>
                    setSubuser({ ...subuser, phone: e.target.value })
                  }
                />
              </VStack>
            </VStack>
          </VStack>
          <Button onClick={handleUpdateSubuser}>{t("subusers.update")}</Button>
        </Container>
      </Box>

      <Footer />
    </Box>
  );
};
